module.exports = __webpack_public_path__ + "static/media/bg_renzheng@2x.b8bd4a5b.png";